import request from '@/utils/request'

// 商品一级分类列表
export function goodsclassOne(params) {
    return request({
        url: '/product/goodsclass/one',
        method: 'get',
        params:params
    })
}

// 商品二级分类列表
export function goodsclassTwo(id) {
    return request({
        url: '/product/goodsclass/' + id,
        method: 'get'
    })
}

// 免审商品查询
export function notcheck(params) {
    return request({
        url: '/product/goodsbase/notcheck/page',
        method: 'get',
        params: params
    })
}

// 查询基础库的更新状态
export function checkRefresh() {
    return request({
        url: '/drug/dataImport/getSynchronizedStatus',
        method: 'get'
    })
}
// 基础库更新状态
export function getbaseDrug() {
    return request({
        url: '/drug/dataImport/synchronizedData',
        method: 'get'
    })
}

// 向指定商品新增图片
export function addImages(data) {
  return request({
      url: '/product/goodsbase/images/add',
      method: 'put',
      data
  })
}

// 执行创建自营控销SQL
export function excSelfControlSQL(data) {
    return request({
        url: '/sales-rule/v1/related/onekey',
        method: 'post',
        data
    })
  }
  // 更新图片
export function updateBaseGoodsImage(data) {
    return request({
        url: '/product/compliance/goodsbase/update/image',
        method: 'post',
        data
})
}
  // 更新经营范围
export function updateScope(data) {
    return request({
        url: '/product/compliance/goodsbase/update/scope',
        method: 'post',
        data
    })
}
// 基础库匹配数量
export function getBaseAmount() {
    return request({
        url: '/product/compliance/goodsbase/getAmount',
        method: 'get'
    })
}
